import theme from '../theme';

/**
 * Canonical status definitions for deficiencies.
 * Keep this module dependency-light so display helpers can share it without cycles.
 */
export const DEFICIENCY_STATUSES = {
    SUBMITTED: {
        value: 'Submitted',
        label: 'Submitted',
        apiValue: 'SUBMITTED',
        color: theme.palette.status.warning,
        pendingDescription: 'Pending',
    },
    ACCEPTED: {
        value: 'Accepted',
        label: 'Accepted',
        apiValue: 'ACCEPTED',
        color: theme.palette.status.warning,
        pendingDescription: 'Awaiting Assignee',
    },
    ASSIGNED: {
        value: 'Assigned',
        label: 'Assigned',
        apiValue: 'ASSIGNED',
        color: theme.palette.status.info,
        pendingDescription: 'Awaiting completion of work',
    },
    WORK_COMPLETED: {
        value: 'Work Completed',
        label: 'Work Completed',
        apiValue: 'WORK_COMPLETED',
        color: theme.palette.status.warning,
        pendingDescription: 'Awaiting internal sign off',
    },
    INTERNALLY_SIGNED_OFF: {
        value: 'Internally Signed Off',
        label: 'Internally Signed Off',
        apiValue: 'INTERNALLY_SIGNED_OFF',
        color: theme.palette.status.info,
        pendingDescription: 'Awaiting external sign off',
    },
    COMPLETED: {
        value: 'Completed',
        label: 'Completed',
        apiValue: 'COMPLETED',
        color: theme.palette.status.success,
        pendingDescription: null,
    },
    REJECTED: {
        value: 'Rejected',
        label: 'Rejected',
        apiValue: 'REJECTED',
        color: theme.palette.status.error,
        pendingDescription: null,
    },
};
